import { render, staticRenderFns } from "./SectionDefaults.vue?vue&type=template&id=5b8134e0&"
import script from "./SectionDefaults.vue?vue&type=script&lang=js&"
export * from "./SectionDefaults.vue?vue&type=script&lang=js&"
import style0 from "./SectionDefaults.vue?vue&type=style&index=0&lang=scss&module=w&"




function injectStyles (context) {
  
  this["w"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports